import React, { useState, useEffect, useCallback } from 'react';
import PostMessageUtil from 'utils/postMessageUtil';

function usePostMessage() {
  const [postMessage, setPostMessage] = useState(null);

  useEffect(() => {
    setPostMessage(new PostMessageUtil());
  }, []);

  const init = () => {
    if (postMessage) {
      postMessage.init();
    }
  };

  const setHeight = useCallback(
    (height) => {
      if (postMessage) {
        postMessage.resetParentFrame(height);
      }
    },
    [postMessage]
  );

  const postParentMessage = useCallback(
    (data) => {
      if (postMessage) {
        postMessage.parentPostMessage(data);
      }
    },
    [postMessage]
  );

  return {
    postMessageInit: init,
    resetParentFrame: setHeight,
    postParentMessage
  };
}

export default usePostMessage;
